import React from "react";
import "../../Styles/informations.css";
import Header from "../Header";
import Footer from "../Footer";

function ConseilScientifiqueScreen() {
  return (
    <>
      <Header />
      <div className="informationScreen my-2">
        <div className="container">
          <div className="row">
            <h1 className="color-orange">
              Organisation administrative de l'EDSDM : Les conseils
            </h1>
            <br></br>
            <hr></hr>
            <br></br>
            <h2>Conseil de l’Ecole Doctorale</h2>
            <br></br>
            <br></br>
            <hr></hr>
            <p>
              Le Conseil de l’Ecole Doctorale examine le programme d’action de
              l’Ecole Doctorale, en particulier en ce qui concerne la formation
              et le dispositif d’aide à l’insertion des doctorants. Il détermine
              les grandes orientations de la politique de l’Ecole Doctorale.
              <br></br>
              <br></br>
              Le Conseil comprend 25 membres dont la proportion relative des
              représentants des établissements et des unités ou équipes de
              recherche concernés (15), des doctorants (5) et des personnalités
              extérieures (5) choisies à part égales dans des domaines
              scientifiques d’une part et dans les secteurs industriels ou
              socio-économiques d’autre part, est fixée par l’arrêté du 25 mai
              2016.
              <br></br>
              <br></br>
              <span className="color-orange mini">
                Feuille de calcul Excel de répartion des allocations 2022
                (version prévisionnelle du 18 février 2022)
              </span>
            </p>
            <br></br>
            <h2>Comptes-rendus du Conseil</h2>
            <br></br>
            <br></br>
            <hr></hr>
            <p className="mini">
              Conseil du 18 février 2022:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 8 novembre 2021:{" "}
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 2 mars 2021:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 4 février 2020:
              <span className="color-orange">
                compte-rendu, présentation
              </span>{" "}
              <br></br> <br></br>
              Conseil du 18 juillet 2019:
              <span className="color-orange">
                compte-rendu, relevé de décision
              </span>{" "}
              <br></br> <br></br>
              Conseil du 30 janvier 2019:
              <span className="color-orange">
                compte-rendu, presentation
              </span>{" "}
              <br></br> <br></br>
              Conseil du 17 janvier 2018:
              <span className="color-orange">
                compte-rendu, presentation, EUR-NanoX
              </span>
              <br></br> <br></br>
              Conseil du 20 février 2017:
              <span className="color-orange">compte-rendu</span> <br></br>{" "}
              <br></br>
              Conseil du 11 juillet 2016:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 17 février 2016:
              <span className="color-orange"> compte-rendu</span>
              <br></br> <br></br>
              Conseil du 15 décembre 2015:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 15 juillet 2015:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 06 février 2015:
              <span className="color-orange">compte-rendu</span> <br></br>{" "}
              <br></br>
              Conseil du 12 décembre 2014:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 19 décembre 2012:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
              Conseil du 16 décembre 2011:
              <span className="color-orange"> présentation, compte-rendu</span>
              <br></br> <br></br>
              Conseil du 12 juillet 2010:
              <span className="color-orange">
                présentation, compte-rendu
              </span>{" "}
              <br></br> <br></br>
            </p>
            <h2>Modalités de fonctionnement du Conseil</h2>
            <br></br>
            <br></br>
            <hr></hr>
            <p>
              Le conseil examine le programme d'action de l'Ecole Doctorale, en
              particulier en ce qui concerne la formation et le dispositif
              d'aide à l'insertion des doctorants. Il détermine les grandes
              orientations de la politique de l'Ecole Doctorale
              <br></br>
              Le directeur de l'Ecole Doctorale présente chaque année un rapport
              d'activité de l'ED devant le Conseil de l'Ecole Doctorale
            </p>

            <h2>Le Conseil Scientifique et Pédagogique (CSP)</h2>
            <br></br>
            <br></br>
            <hr></hr>
            <p>
              Le CSP prend les décisions opérationnelles nécessaires au bon
              fonctionnement de l'Ecole Doctorale. Il organise la répartition
              des allocations de recherche ordinaires attribuées à l'Ecole
              Doctorale et met en place une politique de choix des doctorants
              concernés par ces financements. Il délègue au bureau de l'ED la
              gestion des affaires courantes.
              <br></br>
              <br></br>
              Le CSP est constitué de 15 membres titulaires : les membres du
              bureau ainsi que 10 représentants (binômes titulaire/suppléant)
              des fédérations, laboratoires ou équipes de recherche
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ConseilScientifiqueScreen;
